import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=b3926f1e&"
import script from "./Requests.vue?vue&type=script&lang=js&"
export * from "./Requests.vue?vue&type=script&lang=js&"
import style0 from "./Requests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3926f1e')) {
      api.createRecord('b3926f1e', component.options)
    } else {
      api.reload('b3926f1e', component.options)
    }
    module.hot.accept("./Requests.vue?vue&type=template&id=b3926f1e&", function () {
      api.rerender('b3926f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Requests.vue"
export default component.exports